var site = site || {};
site.inits = [];

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.frontpage = {
	init: function() {
		site.owl.init('.box__sponsors ul', {
			loop: true,
			dots: false,
			nav: true,
			margin: 0,
			items: 1,
			navText: ["", ""],
		});
	}
};

site.readspeker = {
	init: function () {
		$('.paginationControl, .entryFooter').addClass('rs_skip');
	}
};

site.store = {
	init: function () {
		this.fixTaxBreakDown();
	},
	fixTaxBreakDown: function () {
		const totals = document.querySelector('.storeCartViewTotals');
		if (!totals) {
			return;
		}
		const taxTotal = totals.querySelector('.total--productsTax');
		if (taxTotal.querySelector('.value .price .n').innerHTML === '0') {
			taxTotal.classList.add('hide');
		}

	}
}

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});
	site.readspeker.init();
	site.frontpage.init();
	site.store.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	$('#adman #icon-element input').iconpicker();
	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
